import { computed, onScopeDispose, watch, type ComputedRef } from 'vue'
import { useDisplay } from 'vuetify'
import { useAuthStore } from '@/stores/auth'

export type ShellLayout = 'guest' | 'drawer' | 'rail' | 'bottom'

export interface ShellLayoutInput {
  authenticated: boolean
  xs: boolean
  sm: boolean
}

export const BOTTOM_NAV_CLASS = 'fb-has-bottom-nav'

export function shellLayoutFor(input: ShellLayoutInput): ShellLayout {
  if (!input.authenticated) return 'guest'
  if (input.xs) return 'bottom'
  if (input.sm) return 'rail'
  return 'drawer'
}

export function applyBottomNavClass(active: boolean): void {
  document.documentElement.classList.toggle(BOTTOM_NAV_CLASS, active)
}

export function useShellLayout(): { layout: ComputedRef<ShellLayout> } {
  const authStore = useAuthStore()
  const { xs, sm } = useDisplay()
  const layout = computed(() => shellLayoutFor({
    authenticated: authStore.isAuthenticated && !!authStore.currentAccountRole,
    xs: xs.value,
    sm: sm.value,
  }))

  watch(layout, value => applyBottomNavClass(value === 'bottom'), { immediate: true })
  onScopeDispose(() => applyBottomNavClass(false))

  return { layout }
}
